import { fetchGet, fetchPost } from "./serviceClient";

export const createOrder = async (body, accessCookie) => {
  return await fetchPost(
    `${process.env.NEXT_PUBLIC_NEXTJS_API_URL}/checkout/create-order`,
    body,
    accessCookie
  );
};

export const createTransactionToken = async (body) => {
  return await fetchPost(
    `${process.env.NEXT_PUBLIC_NEXTJS_API_URL}/checkout/token`,
    body
  );
};

export const getOrderById = async (orderId) => {
  return await fetchGet(
    `${process.env.NEXT_PUBLIC_NEXTJS_API_URL}/checkout/get-order/${orderId}`
  );
};

export const getValidatedOrderDetails = async (body, accessCookie) => {
  return await fetchPost(
    `${process.env.NEXT_PUBLIC_NEXTJS_API_URL}/checkout/get-validated-order-details`,
    body,
    accessCookie
  );
};

export const verifyRazorpayPayment = async (body, accessCookie) => {
  return await fetchPost(
    `${process.env.NEXT_PUBLIC_NEXTJS_API_URL}/checkout/verify-payment`,
    body,
    accessCookie
  );
};